/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentState = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type PaymentState = typeof PaymentState[keyof typeof PaymentState];


export function instanceOfPaymentState(value: any): boolean {
    for (const key in PaymentState) {
        if (Object.prototype.hasOwnProperty.call(PaymentState, key)) {
            if (PaymentState[key as keyof typeof PaymentState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentStateFromJSON(json: any): PaymentState {
    return PaymentStateFromJSONTyped(json, false);
}

export function PaymentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentState {
    return json as PaymentState;
}

export function PaymentStateToJSON(value?: PaymentState | null): any {
    return value as any;
}

export function PaymentStateToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentState {
    return value as PaymentState;
}

